import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const ShortLinkRedirect = () => {
  const { shortCode } = useParams();
  const [error, setError] = useState(false);

  useEffect(() => {
    const redirectShortLink = async () => {
      try {
        // Call the backend API to get the redirect
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || (window.location.origin.includes('localhost') ? 'http://localhost:8000' : window.location.origin + '/pandvah-backend')}/api/s/${shortCode}`);
        
        if (response.ok) {
          // The backend will handle the redirect, but if we reach here, 
          // it means we need to handle it client-side
          const data = await response.json();
          if (data.redirect_url) {
            window.location.href = data.redirect_url;
          } else {
            setError(true);
          }
        } else {
          // If the API call fails, redirect will be handled by backend
          // This is a fallback in case we need client-side handling
          setError(true);
        }
      } catch (error) {
        console.error('Error redirecting short link:', error);
        setError(true);
      }
    };

    if (shortCode) {
      redirectShortLink();
    } else {
      setError(true);
    }
  }, [shortCode]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Link Not Found</h1>
          <p className="text-gray-600 mb-4">The link you're looking for doesn't exist or has expired.</p>
          <a 
            href="/review-us" 
            className="inline-block bg-theme-blue text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Reviews Page
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-theme-blue mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default ShortLinkRedirect;